import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ContextState } from './context.state';

export const selectContext = createFeatureSelector<ContextState>('context');

export const selectContextId = createSelector(
  selectContext,
  (state: ContextState) => state.contextId
);

export const selectContextData = createSelector(
  selectContext,
  (state: ContextState) => state.contextData
);
